(() => {
  'use strict';

  const money = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });

  document.querySelectorAll('[data-neon-configurator]').forEach(initConfigurator);

  function initConfigurator(root) {
    if (root.dataset.ngInitialized === "canvas-v2") return;
    root.dataset.ngInitialized = "canvas-v2";
    const form = root.querySelector('[data-config-form]');
    const preview = root.querySelector('[data-preview]');
    const neonText = root.querySelector('[data-neon-text]');
    const backboard = root.querySelector('[data-backboard]');
    const cutBoard = root.querySelector('[data-cut-board]');
    const cutShapes = root.querySelector('[data-cut-shapes]');
    const cutEdge = root.querySelector('[data-cut-edge]');
    const cutNeon = root.querySelector('[data-cut-neon]');
    const textInput = root.querySelector('#neonText');
    const priceOutput = root.querySelector('[data-total-price]');
    const summary = root.querySelector('[data-summary]');
    const colorName = root.querySelector('[data-color-name]');
    const count = root.querySelector('[data-char-count]');
    const scale = root.querySelector('[data-scale-label]');
    const message = root.querySelector('[data-form-message]');
    const submitButton = form.querySelector('button[type="submit"]');
    const submitLabel = submitButton?.querySelector('span');
    const defaultSubmitText = submitLabel?.textContent || 'Voeg ontwerp toe aan winkelwagen';
    const variantInput = root.querySelector('[data-variant-input]');

    if (root.dataset.variantId) variantInput.value = root.dataset.variantId;

    root.addEventListener('change', async event => {
      const input = event.target;

      if (!input.matches('input, select')) return;
      if (input.matches('input[type="radio"]')) markSelected(input);

      if (input.matches('input[name="properties[Lettertype]"]')) {
        const fontFamily = input.dataset.font;
        if (fontFamily) {
          neonText.style.fontFamily = fontFamily;
          backboard.style.setProperty('--neon-font', fontFamily);

          const primaryFont = fontFamily
            .split(',')[0]
            .trim()
            .replace(/^['"]|['"]$/g, '');

          if (document.fonts?.load) {
            try {
              await document.fonts.load(`64px "${primaryFont}"`);
            } catch (error) {
              console.warn(`Lettertype ${primaryFont} kon niet vooraf worden geladen.`, error);
            }
          }

          const text = textInput.value.trim() || 'Jouw tekst';
          const currentFontSize = parseFloat(
            getComputedStyle(backboard).getPropertyValue('--neon-size')
          ) || 82;
          drawUnifiedCutBoard(text, fontFamily, currentFontSize);
        }
      }

      update();
    });
    textInput.addEventListener('input', () => {
      const lines = textInput.value.split('\n').slice(0, 2);
      if (textInput.value.split('\n').length > 2) textInput.value = lines.join('\n');
      update();
    });

    root.querySelector('[data-action="toggle-lights"]').addEventListener('click', event => {
      preview.classList.toggle('is-off');
      event.currentTarget.setAttribute('aria-pressed', String(preview.classList.contains('is-off')));
    });

    root.querySelector('[data-action="reset"]').addEventListener('click', event => {
      event.preventDefault();
      form.reset();
      root.querySelectorAll('.ng-choice, .ng-color-grid label').forEach(el => el.classList.remove('is-selected'));
      form.querySelectorAll('input:checked').forEach(markSelected);
      preview.classList.remove('is-off');
      root.querySelector('[data-action="toggle-lights"]').setAttribute('aria-pressed', 'false');
      message.textContent = '';
      message.className = 'ng-form-message';
      submitButton.disabled = false;
      if (submitLabel) submitLabel.textContent = defaultSubmitText;
      update();
    });

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!textInput.value.trim()) {
        textInput.focus();
        showMessage('Vul eerst de tekst voor je neon sign in.', 'error');
        return;
      }

      const variantId = variantInput.value || root.dataset.variantId;
      if (!variantId) {
        showMessage('De configurator werkt. Voeg in Shopify nog het variant-ID toe om bestellen te activeren.', 'error');
        return;
      }

      submitButton.disabled = true;
      if (submitLabel) submitLabel.textContent = 'Ontwerpafbeelding maken…';
      try {
        const previewImage = await createPreviewPng();
        const designId = createDesignId();
        const cartData = new FormData(form);

        cartData.set('id', variantId);
        cartData.set('quantity', '1');
        cartData.set('properties[Berekende prijs]', priceOutput.textContent);
        cartData.set('properties[Ontwerp-ID]', designId);
        cartData.set(
          'properties[Ontwerp preview]',
          previewImage,
          `${designId}.png`
        );

        if (submitLabel) submitLabel.textContent = 'Naar veilig betalen…';
        const shopRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: cartData
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || `Shopify-fout ${response.status}`);
        }

        const addedResponse = await response.json();
        const addedItem = addedResponse?.items?.[0] || addedResponse;
        const savedPreview = addedItem?.properties?.['Ontwerp preview'];

        if (!savedPreview) {
          throw new Error('Shopify heeft het product toegevoegd, maar de ontwerpafbeelding niet opgeslagen.');
        }

        showMessage('Je ontwerp en afbeelding zijn opgeslagen. Je gaat nu naar betalen…', 'success');
        window.location.assign(`${shopRoot}checkout`);
      } catch (error) {
        console.error(error);
        showMessage(`Toevoegen is niet gelukt: ${error.message}`, 'error');
        submitButton.disabled = false;
        if (submitLabel) submitLabel.textContent = defaultSubmitText;
      }
    });

    function createDesignId() {
      const date = new Date();
      const datePart = [
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0')
      ].join('');
      const textPart = (textInput.value.trim() || 'NEON')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/gi, '-')
        .replace(/^-|-$/g, '')
        .slice(0, 18)
        .toUpperCase() || 'NEON';
      const randomPart = Math.random().toString(36).slice(2, 8).toUpperCase();

      return `NG-${datePart}-${textPart}-${randomPart}`;
    }

    async function createPreviewPng() {
      if (!preview) throw new Error('De ontwerpweergave kon niet worden gevonden.');
      const fontFamily = checked('[data-font]').dataset.font;
      const text = textInput.value.trim();
      const lines = text.split('\n').slice(0, 2);
      const color = checked('[data-color]').dataset.color;
      const board = checked('[data-board]').dataset.board;
      const scene = checked('[data-background]').dataset.background;
      if (document.fonts?.load) await document.fonts.load(`96px ${fontFamily}`, text);
      if (document.fonts?.ready) await document.fonts.ready;

      const canvas = document.createElement('canvas');
      const bounds = preview.getBoundingClientRect();
      const width = Math.max(1, Math.round(bounds.width));
      const height = Math.max(1, Math.round(bounds.height));
      const ratio = Math.min(2, window.devicePixelRatio || 1);
      canvas.width = Math.round(width * ratio);
      canvas.height = Math.round(height * ratio);
      const ctx = canvas.getContext('2d');
      if (!ctx) throw new Error('Canvas wordt niet ondersteund door deze browser.');
      ctx.scale(ratio, ratio);

      const backgrounds = { brick: '#191b1e', concrete: '#35383c', warm: '#49382e', light: '#d9d7d2' };
      ctx.fillStyle = backgrounds[scene] || backgrounds.brick;
      ctx.fillRect(0, 0, width, height);
      const isOff = preview.classList.contains('is-off');
      if (!isOff) {
        const glow = ctx.createRadialGradient(width / 2, height / 2, 0, width / 2, height / 2, Math.max(width, height) * .55);
        glow.addColorStop(0, color + '35');
        glow.addColorStop(1, color + '00');
        ctx.fillStyle = glow;
        ctx.fillRect(0, 0, width, height);
      }
      if (scene === 'brick') {
        ctx.strokeStyle = 'rgba(255,255,255,0.035)';
        ctx.lineWidth = 1;
        for (let y = 0, row = 0; y < height; y += 48, row++) {
          ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(width, y); ctx.stroke();
          for (let x = row % 2 ? 48 : 0; x < width; x += 96) {
            ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x, y + 48); ctx.stroke();
          }
        }
      }

      let fontSize = parseFloat(getComputedStyle(backboard).getPropertyValue('--neon-size')) || 82;
      ctx.font = `${fontSize}px ${fontFamily}`;
      const initialWidth = Math.max(...lines.map(line => ctx.measureText(line || ' ').width), 1);
      const fit = Math.min(1, (width * .82 - 36) / initialWidth, (height * .75 - 36) / (lines.length * fontSize * 1.25));
      fontSize *= Math.max(.1, fit);
      ctx.font = `${fontSize}px ${fontFamily}`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'alphabetic';
      const lineHeight = fontSize * 1.25;
      const metrics = ctx.measureText('Mg');
      const ascent = metrics.actualBoundingBoxAscent || fontSize * .78;
      const descent = metrics.actualBoundingBoxDescent || fontSize * .22;
      const leading = Math.max(0, lineHeight - ascent - descent);
      const top = (height - lineHeight * lines.length) / 2;
      const ys = lines.map((_, i) => top + leading / 2 + ascent + i * lineHeight);
      const widths = lines.map(line => Math.max(80, ctx.measureText(line || ' ').width));

      const plate = document.createElement('canvas');
      plate.width = canvas.width; plate.height = canvas.height;
      const p = plate.getContext('2d');
      if (!p) throw new Error('De achterplaat kon niet worden getekend.');
      p.scale(ratio, ratio);
      p.font = ctx.font; p.textAlign = 'center'; p.textBaseline = 'alphabetic';
      p.fillStyle = '#fff'; p.strokeStyle = '#fff'; p.lineJoin = 'round';
      if (board === 'rectangle') {
        const w = Math.max(...widths) + 36;
        p.fillRect((width - w) / 2, top - 17, w, lineHeight * lines.length + 34);
      } else {
        p.lineWidth = 26;
        lines.forEach((line, i) => {
          p.strokeText(line, width / 2, ys[i]); p.fillText(line, width / 2, ys[i]);
          p.fillRect((width - widths[i]) / 2 + 5, ys[i] - fontSize * .34, Math.max(12, widths[i] - 10), 4);
        });
        if (lines.length === 2) p.fillRect(width / 2 - 2.5, ys[0] - 2, 5, ys[1] - ys[0] + 4);
      }
      p.globalCompositeOperation = 'source-in';
      p.fillStyle = 'rgba(220,233,235,0.17)';
      p.fillRect(0, 0, width, height);
      ctx.drawImage(plate, 0, 0, width, height);

      if (isOff) {
        ctx.fillStyle = '#dedede';
        lines.forEach((line, i) => ctx.fillText(line, width / 2, ys[i]));
      } else {
        ctx.fillStyle = color; ctx.shadowColor = color;
        for (const blur of [24, 12, 5]) {
          ctx.shadowBlur = blur * ratio;
          lines.forEach((line, i) => ctx.fillText(line, width / 2, ys[i]));
        }
        ctx.shadowBlur = 0; ctx.fillStyle = '#fffaf3';
        lines.forEach((line, i) => ctx.fillText(line, width / 2, ys[i]));
      }
      return new Promise((resolve, reject) => {
        try {
          canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('De ontwerpafbeelding kon niet worden gemaakt.')), 'image/png');
        } catch (error) { reject(error); }
      });
    }

    function update() {
      const text = textInput.value.trim() || 'Jouw tekst';
      const font = checked('[data-font]');
      const color = checked('[data-color]');
      const size = checked('[data-width]');
      const board = checked('[data-board]');
      const background = checked('[data-background]');
      neonText.textContent = text;
      backboard.dataset.text = text;
      backboard.style.setProperty('--neon-font', font.dataset.font);
      preview.style.setProperty('--neon-color', color.dataset.color);
      colorName.textContent = color.value;
      scale.textContent = `± ${size.dataset.width} cm breed`;
      variantInput.value = size.dataset.variantId || root.dataset.variantId || '';
      backboard.className = `ng-backboard ng-board--${board.dataset.board}`;
      backboard.style.removeProperty('width');
      backboard.style.removeProperty('height');
      preview.className = `ng-preview ng-scene--${background.dataset.background}${preview.classList.contains('is-off') ? ' is-off' : ''}`;

      const chars = textInput.value.replace(/\n/g, '').length;
      count.textContent = `${Math.max(0, 24 - chars)} tekens over`;
      const availableWidth = Math.min(preview.clientWidth * (board.dataset.board === 'cut-shape' ? .86 : .8), 760);
      const lines = text.split('\n');
      const longestLine = Math.max(...lines.map(line => line.length), 1);
      const estimatedCharacterWidth = /Bebas|Oswald|Inter|Courier/.test(font.dataset.font) ? .58 : .68;
      const fittedSize = availableWidth / (longestLine * estimatedCharacterWidth);
      const fontSize = Math.max(36, Math.min(board.dataset.board === 'cut-shape' ? 112 : 96, fittedSize));
      backboard.style.setProperty('--neon-size', `${fontSize}px`);
      drawUnifiedCutBoard(text, font.dataset.font, fontSize);

      let price = Number(size.dataset.price);
      form.querySelectorAll('input[type="radio"]:checked[data-price]').forEach(input => {
        if (!input.matches('[data-width]')) price += Number(input.dataset.price || 0);
      });
      priceOutput.textContent = money.format(price);
      summary.textContent = `${text.replace(/\n/g, ' / ')} · ${size.value} · ${color.value}`;
    }

    function drawUnifiedCutBoard(text, fontFamily, fontSize) {
      const lines = text.split('\n').slice(0, 2);
      const canvas = drawUnifiedCutBoard.canvas || (drawUnifiedCutBoard.canvas = document.createElement('canvas'));
      const context = canvas.getContext('2d');
      context.font = `${fontSize}px ${fontFamily}`;
      const measured = lines.map(line => Math.max(80, context.measureText(line || ' ').width));
      const metrics = context.measureText('Mg');
      const ascent = metrics.actualBoundingBoxAscent || fontSize * .78;
      const descent = metrics.actualBoundingBoxDescent || fontSize * .22;
      const padX = 18;
      const padY = 17;
      const lineHeight = fontSize * 1.25;
      const width = Math.max(...measured) + padX * 2;
      const height = lineHeight * lines.length + padY * 2;
      cutBoard.setAttribute('viewBox', `0 0 ${width} ${height}`);
      const nodes = [];
      const leading = Math.max(0, lineHeight - ascent - descent);
      const baselines = lines.map((_, index) => padY + leading / 2 + ascent + index * lineHeight);
      const neonNodes = [];

      lines.forEach((line, index) => {
        const textNode = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        textNode.setAttribute('x', String(width / 2));
        textNode.setAttribute('y', String(baselines[index]));
        textNode.setAttribute('text-anchor', 'middle');
        textNode.setAttribute('font-family', fontFamily);
        textNode.style.fontFamily = fontFamily;
        textNode.setAttribute('font-size', String(fontSize));
        textNode.textContent = line || ' ';
        nodes.push(textNode);
        neonNodes.push(textNode.cloneNode(true));

        const connector = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        connector.setAttribute('x', String((width - measured[index]) / 2 + 5));
        connector.setAttribute('y', String(baselines[index] - fontSize * .34));
        connector.setAttribute('width', String(Math.max(12, measured[index] - 10)));
        connector.setAttribute('height', '4');
        connector.setAttribute('rx', '2');
        nodes.push(connector);
      });

      if (lines.length === 2) {
        const bridge = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        bridge.setAttribute('x', String(width / 2 - 2.5));
        bridge.setAttribute('y', String(baselines[0] - 2));
        bridge.setAttribute('width', '5');
        bridge.setAttribute('height', String(baselines[1] - baselines[0] + 4));
        bridge.setAttribute('rx', '2.5');
        nodes.push(bridge);
      }

      cutShapes.replaceChildren(...nodes.map(node => node.cloneNode(true)));
      cutEdge.replaceChildren(...nodes);
      cutNeon.replaceChildren(...neonNodes);
      if (backboard.classList.contains('ng-board--cut-shape')) {
        backboard.style.width = `${width}px`;
        backboard.style.height = `${height}px`;
      }
    }

    function checked(selector) {
      return form.querySelector(`input:checked${selector}`);
    }

    function markSelected(input) {
      const group = input.closest('.ng-font-grid, .ng-size-grid, .ng-board-grid, .ng-two-grid, .ng-color-grid, .ng-background-grid');
      if (!group) return;
      group.querySelectorAll('.is-selected').forEach(el => el.classList.remove('is-selected'));
      input.closest('label').classList.add('is-selected');
    }

    function showMessage(text, type) {
      message.textContent = text;
      message.className = `ng-form-message is-visible is-${type}`;
    }

    update();
    if (document.fonts?.ready) document.fonts.ready.then(update);
  }
})();
